// extracted by mini-css-extract-plugin
export default {"relogioNumero":"relogio_relogioNumero__O3AzI","relogioDivisao":"relogio_relogioDivisao__w-MTu"};